// extracted by mini-css-extract-plugin
export default {"examItem":"_ExamItem_examItem__6CKTr"};